function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { nextDate, nextMonth as _nextMonth, nextYear as _nextYear, prevDate, prevMonth as _prevMonth, prevYear as _prevYear } from '@okee-uikit/react-utils';
import { RangeState } from '../util';
export var PanelType;

(function (PanelType) {
  PanelType["WEEK"] = "week";
  PanelType["DATE"] = "date";
  PanelType["MONTH"] = "month";
  PanelType["YEAR"] = "year";
})(PanelType || (PanelType = {}));

export var BasePanel = function (_Emitter) {
  _inherits(BasePanel, _Emitter);

  var _super = _createSuper(BasePanel);

  function BasePanel(options, owner) {
    var _this;

    _classCallCheck(this, BasePanel);

    _this = _super.call(this);
    _this.hidePrev = false;
    _this.hideNext = false;
    var root = options.root,
        date = options.date,
        part = options.part;
    _this.root = root;
    _this.date = date || new Date();
    _this.part = part;
    _this.owner = owner || _assertThisInitialized(_this);
    return _this;
  }

  _createClass(BasePanel, [{
    key: "updateDate",
    value: function updateDate(date) {
      var isSilent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var virtual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var setPanelDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var owner = this.owner;

      if (!isSilent && owner === this) {
        this.root.setPanelSelected(date, this.part, virtual);
      }

      if (!virtual) {
        owner.syncCurrentDate(date);
        setPanelDate && this.root.setPanelDate(this.part, date);
      }

      owner.emit('repaint');
    }
  }, {
    key: "frameSelectDate",
    value: function frameSelectDate(list, type, virtual) {
      var owner = this.owner;

      if (owner === this) {
        this.root.setPanelFrameSelected(list, this.part, type, virtual);
      }
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return this.date;
    }
  }, {
    key: "getPart",
    value: function getPart() {
      return this.part;
    }
  }, {
    key: "isDateDisabled",
    value: function isDateDisabled(date) {
      return this.root.isDateDisabled(date, this.part);
    }
  }, {
    key: "isWeekDisabled",
    value: function isWeekDisabled(date) {
      return this.root.isWeekDisabled(date, this.part);
    }
  }, {
    key: "isMonthDisabled",
    value: function isMonthDisabled(date) {
      return this.root.isMonthDisabled(date, this.part);
    }
  }, {
    key: "isYearDisabled",
    value: function isYearDisabled(date) {
      return this.root.isYearDisabled(date, this.part);
    }
  }, {
    key: "isWeekSelected",
    value: function isWeekSelected(date) {
      return this.root.isWeekSelected(date);
    }
  }, {
    key: "getWeekSelectedState",
    value: function getWeekSelectedState(date) {
      return this.root.getWeekSelectedState(date);
    }
  }, {
    key: "isDateSelected",
    value: function isDateSelected(date) {
      return this.root.isDateSelected(date);
    }
  }, {
    key: "isDateToday",
    value: function isDateToday(date) {
      return this.root.isToday(date);
    }
  }, {
    key: "isMonthSelected",
    value: function isMonthSelected(date) {
      return this.root.isMonthSelected(date);
    }
  }, {
    key: "isYearSelected",
    value: function isYearSelected(date) {
      return this.root.isYearSelected(date);
    }
  }, {
    key: "prevMonth",
    value: function prevMonth() {
      this.updateDate(_prevMonth(this.date), true);
    }
  }, {
    key: "nextMonth",
    value: function nextMonth() {
      this.updateDate(_nextMonth(this.date), true);
    }
  }, {
    key: "prevYear",
    value: function prevYear() {
      this.updateDate(_prevYear(this.date), true);
    }
  }, {
    key: "nextYear",
    value: function nextYear() {
      this.updateDate(_nextYear(this.date), true);
    }
  }, {
    key: "prevTenYear",
    value: function prevTenYear() {
      this.updateDate(_prevYear(this.date, 10), true);
    }
  }, {
    key: "nextTenYear",
    value: function nextTenYear() {
      this.updateDate(_nextYear(this.date, 10), true);
    }
  }, {
    key: "repaint",
    value: function repaint() {
      this.emit('repaint');
    }
  }, {
    key: "getStartDay",
    value: function getStartDay() {
      return this.root.getStartDay();
    }
  }, {
    key: "getSelectedState",
    value: function getSelectedState(date) {
      if (!this.isOwner()) {
        return this.isSelected(date, this.getPanelType()) ? RangeState.SINGLE : RangeState.NONE;
      }

      return this.root.getSelectedState(date);
    }
  }, {
    key: "getTryingSelectedState",
    value: function getTryingSelectedState(date) {
      if (!this.isOwner()) {
        return RangeState.NONE;
      }

      return this.root.getTryingSelectedState(date);
    }
  }, {
    key: "isInvalidTryingDate",
    value: function isInvalidTryingDate() {
      if (!this.isOwner()) {
        return false;
      }

      return this.root.isInvalidTryingDate();
    }
  }, {
    key: "setDate",
    value: function setDate(date) {
      this.date = date;
    }
  }, {
    key: "getCurrentYear",
    value: function getCurrentYear() {
      return this.date.getFullYear();
    }
  }, {
    key: "getCurrentMonth",
    value: function getCurrentMonth() {
      return this.date.getMonth();
    }
  }, {
    key: "getDayList",
    value: function getDayList() {
      var startDay = this.getStartDay();
      var dayList = [];

      for (var i = 0; i < 7; i++) {
        dayList[i] = (i + startDay + 7) % 7;
      }

      return dayList;
    }
  }, {
    key: "getCurrentType",
    value: function getCurrentType() {
      return this.currentType;
    }
  }, {
    key: "setCurrentType",
    value: function setCurrentType(type) {
      this.currentType = type;
      this.emit('repaint');
    }
  }, {
    key: "setHidePrev",
    value: function setHidePrev(hidePrev) {
      this.hidePrev = hidePrev;
      this.emit('repaint');
    }
  }, {
    key: "setHideNext",
    value: function setHideNext(hideNext) {
      this.hideNext = hideNext;
      this.emit('repaint');
    }
  }, {
    key: "getHidePrev",
    value: function getHidePrev() {
      return this.hidePrev;
    }
  }, {
    key: "getHideNext",
    value: function getHideNext() {
      return this.hideNext;
    }
  }, {
    key: "getOutRangeDisabled",
    value: function getOutRangeDisabled() {
      return this.root.getOutRangeDisabled();
    }
  }, {
    key: "isOwner",
    value: function isOwner() {
      return this.owner === this;
    }
  }, {
    key: "getDisabledState",
    value: function getDisabledState(date) {
      var type = this.getPanelType();
      var disabled = this.isDisabled(date, type);

      if (!disabled) {
        return RangeState.NONE;
      }

      var prevDisabled = this.isDateDisabled(prevDate(date));
      var nextDisabled = this.isDateDisabled(nextDate(date));

      if (prevDisabled && nextDisabled) {
        return RangeState.IN;
      }

      if (prevDisabled) {
        return RangeState.END;
      }

      if (nextDisabled) {
        return RangeState.START;
      }

      return RangeState.SINGLE;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(date, type) {
      switch (type) {
        case PanelType.DATE:
          return this.isDateDisabled(date);

        case PanelType.MONTH:
          return this.isMonthDisabled(date);

        case PanelType.YEAR:
          return this.isYearDisabled(date);

        case PanelType.WEEK:
          return this.isWeekDisabled(date);
      }
    }
  }, {
    key: "isSelected",
    value: function isSelected(date, type) {
      switch (type) {
        case PanelType.DATE:
          return this.isDateSelected(date);

        case PanelType.MONTH:
          return this.isMonthSelected(date);

        case PanelType.YEAR:
          return this.isYearSelected(date);

        case PanelType.WEEK:
          return this.isWeekSelected(date);
      }
    }
  }]);

  return BasePanel;
}(Emitter);